import { useQuery } from 'react-query';
import { ObjectService as objs } from '../api/ObjectService';
import { GenerateGETSignedUrlRequest } from '../api/protosCompiled/object/object_pb';
import { useLocalStorage } from '../stores/localStorage';
import { useStore } from 'zustand';

export const useFetchObject = (selectedObjectName: string | null) => {
  const sessionToken = useStore(useLocalStorage).sessionToken;

  return useQuery(
    ['object', selectedObjectName],
    async () => {
      if (!selectedObjectName || !sessionToken) return null;

      const request = new GenerateGETSignedUrlRequest();
      request.setSessiontoken(sessionToken);
      request.setMethod('GET');
      request.setGcsobjectname(selectedObjectName);

      return await objs.handleGETGCSRequest(request, selectedObjectName);
    },
    {
      refetchOnWindowFocus: false,
      enabled: !!selectedObjectName,
      // Allow stale data to be garbage collected after 10 minutes of inactivity
      staleTime: 10 * 60 * 1000,
      // Set a cacheTime to allow garbage collection after 15 minutes
      cacheTime: 15 * 60 * 1000,
      onError: error => {
        console.error('Error fetching object URL:', error);
      },
    }
  );
};

export const useFetchPendingDocuments = (projectId: string) => {
  const { data, error, isLoading, isFetching, refetch } = useQuery(
    'pending-documents',
    async () => {
      const response = await objs.getPendingDocuments(projectId);
      return response.documentsList;
    },
    {
      refetchOnWindowFocus: false,
      enabled: !!projectId,
      staleTime: 250000, //5 minutes
      onError: error => {
        console.error('Error fetching pending documents:', error);
      },
    }
  );

  return { data, error, isLoading, isFetching, refetch };
};
